import { useEffect, useState } from 'react'

import Container from 'react-bootstrap/Container'
import Table from 'react-bootstrap/Table'

import { FaFrown } from 'react-icons/fa'

import FiltrosPontosDeVendaEmpresaA2A2 from './FiltrosPontosDeVendaEmpresaA2A2'

import constantes from '../helpers/constanteHelper'

function PontosDeVenda({ pontosDeVenda, resolucaoMobile, exibirMenu }) {
    // Controle de cidades e estados únicos para o filtro
    const [cidades, setCidades] = useState([]);
    const [estados, setEstados] = useState([]);

    // Filtros
    const [filtroCidade, setFiltroCidade] = useState();
    const [filtroEstado, setFiltroEstado] = useState();

    useEffect(() => {
        const novasCidades = new Set()
        const novosEstados = new Set()

        pontosDeVenda?.forEach((pontoVenda) => {
            novasCidades.add(pontoVenda['Cidade'])
            novosEstados.add(pontoVenda['Estado'])
        })

        setCidades([...novasCidades].sort((a, b) => a.localeCompare(b)))
        setEstados([...novosEstados].sort((a, b) => a.localeCompare(b)))
    }, []);

    return (
        <div className='mb-5 animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <div className='mb-5'>
                <h1 className='mt-5 me-2 ms-2' style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Pontos de venda da marca</h1>
                <span style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '14px' : '18px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center', }}>Importante: a disponibilidade dos produtos da marca dependerá do estoque do ponto de venda.</span>
            </div>

            <FiltrosPontosDeVendaEmpresaA2A2
                estados={[...estados]}
                cidades={[...cidades]}
                filtroEstado={filtroEstado}
                setFiltroEstado={setFiltroEstado}
                filtroCidade={filtroCidade}
                setFiltroCidade={setFiltroCidade}
            />

            <div style={{ width: resolucaoMobile ? '90vw' : '80vw', gap: '20px' }} className='mb-5 d-flex flex-column flex-wrap align-items-center justify-content-center'>
                <Container className='animate__animated animate__fadeIn ' >
                    <Table striped bordered hover responsive className='text-center' >
                        <thead style={{ height: '60px', verticalAlign: 'middle' }}>
                            <tr>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.AZUL_A2A2 }}>Ponto de venda</th>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.AZUL_A2A2 }}>Estado</th>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.AZUL_A2A2 }}>Cidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pontosDeVenda?.filter((pontoDeVenda) => {
                                if (filtroCidade && filtroEstado) {
                                    return pontoDeVenda['Cidade'] === filtroCidade && pontoDeVenda['Estado'] === filtroEstado
                                }

                                if (filtroCidade && !filtroEstado) {
                                    return pontoDeVenda['Cidade'] === filtroCidade
                                }

                                if (!filtroCidade && filtroEstado) {
                                    return pontoDeVenda['Estado'] === filtroEstado
                                }

                                return true
                            }).map((pontoDeVenda) =>
                                <tr>
                                    <td style={{ backgroundColor: constantes.CORES.AZUL_A2A2 }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>{pontoDeVenda['Nome']}</span></td>
                                    <td style={{ backgroundColor: constantes.CORES.AZUL_A2A2 }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>{pontoDeVenda['Estado']}</span></td>
                                    <td style={{ backgroundColor: constantes.CORES.AZUL_A2A2 }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>{pontoDeVenda['Cidade']}</span></td>
                                </tr>)}
                        </tbody>
                    </Table>

                    {pontosDeVenda?.length > 0
                        ? <></>
                        : <div style={{ gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center'>
                            <FaFrown size={120} color={constantes.CORES.BRANCO_PADRAO} />

                            <div>
                                <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>Ainda não há dados para exibir.</span>
                                <div></div>
                                <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>Em breve eles estarão disponíveis.</span>
                            </div>
                        </div>
                    }

                    <div style={{ height: '100px' }}></div>
                </Container>
            </div>
        </div>
    );
}

export default PontosDeVenda